export default __webpack_public_path__ + "static/media/ETH-logo.1bce669a.png";